import { Component, OnInit } from '@angular/core';
import { MainService } from '../../service/main.service';
import { Exam } from '../../model/Exam';
import {
	ActivatedRoute,
	NavigationEnd,
	Router,
	RouterOutlet,
} from '@angular/router';
import { KeyValue } from '../../model/KeyValue';
import { Admission } from '../../model/Admission';
import { Document } from '../../model/Document';
import { Location } from '@angular/common';
import { Course } from '../../model/Course';


export interface Step {
  label: string;
	description: string;
}

export class Condition {
  label: string = '';
	subconditions: string = '';
  position: number | null = null
}

export enum Conditions {
  LANGUAGE = 'Competenze linguistiche',
  DEGREE= 'Voto di Laurea',
  EXAMS=  'Percorso di studi pregresso',
}

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
	admission: Admission = new Admission();
	course!: string;
	school!: string;
	courseTypes: Array<KeyValue> = [];
	schools: Array<KeyValue> = [];
    documents: Array<Document> = [];
    dipartimenti: Array<KeyValue> = [];
	dipartimento: KeyValue = new KeyValue();
	contactEmail: string = '';
	chat!: boolean;
	question!: string;
	answer!: string;
	asking: boolean = false;
	showTemplate: boolean = false;
	showTrace: boolean = false;
	template: string = '';
	trace!: string;
	reasons!: any;
	reason!: string;
	admission_id!: string;
	short_id!: string;
	prompt!: string;
	failurePattern: Array<string> = ['RISPOSTA FINALE (SI/NO): No', 'No '];
	successPattern: Array<string> = ['RISPOSTA FINALE (SI/NO): Si', 'Si '];
	ssds: Array<KeyValue> = [];
	languageLevels: Array<KeyValue> = [];
	savingMessage: string | null = null;
	documentParseOk: boolean | null = null;

	degreeTypes: Array<KeyValue> = [];
	degree_votes: Array<KeyValue> = [];
	selectedFile: File | null = null;
	documentProcessing = false;
	currentStep: number = 2;
	insertMode: string = 'upload';

	manualMode: string = 'manual';
	uploadMode: string = 'upload';

  conditionsOrder: Array<string> = [
    Conditions.DEGREE,
    Conditions.EXAMS,
    Conditions.LANGUAGE
  ]

	public applicationError: boolean = false;
	public askError: boolean = false;

	public files: File[] = [];

  // public examsAverage: number | null = null
  public examVotes: number[] = [18,19,20,21,22,23,24,25,26,27,28,29,30]

	constructor(
		private _mainService: MainService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private _location: Location
	) {
		activatedRoute.queryParams.subscribe((params) => {
			this.currentStep = params['step'] ? parseInt(params['step']) : 2;
      if(this.currentStep === 4 && !this.askDisabled()) {
        this.ask();
      }
		});
	}

	/**
	 * On init
	 */
	ngOnInit() {
		this.getSSD();
		const idAdmission = this.activatedRoute.snapshot.params['id_admission'];
		if (idAdmission) {
			this._mainService.getAdmission(idAdmission).subscribe((admission) => {
				if (admission) {
					this.admission = admission;
				}
			});
		}
		this.router.navigate(['/'], { queryParams: { step: 2 } });
	}

	stepInError(step: number) {
		let isInError = false;
		switch (step) {
			case 2:
				// isInError = !this.admission.degree_type || !this.admission.exam_vote;
				isInError = false;
				break;
			case 3:
				isInError = !this.course;
				break;
			case 4:
				isInError = this.answer.trim() !== '' && this.isFailure();
				break;
		}

		return isInError;
	}

	steps() {
		return [
			// {
			// 	label: 'Modalità',
			// 	description: this.isUpload()
			// 		? 'Dichiarazione sostitutiva'
			// 		: 'Inserimento manuale',
			// },
			{
				label: 'Modalità',
				description: 'Inserimento manuale',
			},
			// {
			// 	label: 'Laurea ed Esami',
			// 	description: this.isUpload()
			// 		? 'Controllo Dati estratti'
			// 		: 'Inserimento dati',
			// },
			{
				label: 'Laurea ed Esami',
				description: 'Inserimento dati',
			},
			{
				label: 'Scelta Corso',
				description: this.course
					? this.getCourseByKey(this.course)
					: 'Selezione Corso',
			},
			{
				label: 'Esito',
				description: this.answer
					? this.isFailure()
						? 'Non idoneo'
						: 'Idoneo'
					: '-',
			},
		];
	}

	getCourseByKey(courseKey: string) {
		return this.courseTypes.filter(
			(course: any) => course['key'] === courseKey
		)[0]['value'];
	}

	degreeNameByKey(degreeKey: string) {
		return this.degreeTypes.filter(
			(degree: any) => degree['key'] === degreeKey
		)[0]['value'];
	}

  isLanguage(condition: Condition){
    return condition.label === Conditions.LANGUAGE
  }

  allAlternativesFailed(condition: Condition){
    let somePassed = false;
    Object.values(condition.subconditions).forEach((subcondition: any) => {
      subcondition['message'].forEach((subsubcondition: any) => {
        if(subsubcondition.passed){
          somePassed = true;
        }
      });
    });
    return !somePassed;
  }

	isUpload() {
		return this.insertMode === 'upload';
	}

	isManual() {
		return this.insertMode === 'manual';
	}

	setInsertMode(mode: string) {
		this.insertMode = mode;
	}

	onValueChange(file: File[]) {
		this.files = file;
		this.selectedFile = file[0];
		this.onFileSubmit();
	}

	cleanFile() {
		this.files = [];
		this.documentParseOk = null;
		this.selectedFile = null;
	}

	goNextStep() {
		this.currentStep++;
		this.router.navigate(['/'], { queryParams: { step: this.currentStep } });
	}

	nextStepDisabled() {
		return (
			(this.currentStep === 1 && this.isUpload() && !this.documentParseOk) ||
			(this.currentStep === 3 && !this.course)
		);
	}

	resetAnswer() {
		this.answer = '';
	}

	goPreviousStep() {
		this.currentStep--;
		this._location.back();
	}

  askDisabled(){
    return this.asking || this.course==null || this.course==='' || this.school==null || this.school===''
  }

	previousStepDisabled() {
		return this.currentStep <= 2;
	}

	isChat() {
		return false;
	}

	isAdmission() {
		return true;
	}

	getAskType() {
		return false ? 'chat' : 'admission';
	}

	changeAskType() {
		// this.getTemplate();
		// this.answer = '';
	}

	filteredCourseTypes() {
		return this.courseTypes.filter(
			(course: any) => course['school'] === this.school
		);
	}

	schoolByKey(key: string) {
		return this.schools.filter((school: any) => school['key'] === key)[0][
			'value'
		];
	}

	isPsychologySchool(): boolean {
		if (!this.school || !this.schools || this.schools.length === 0) {
			return false;
		}
		const match = this.schools.filter((school: any) => school['key'] === this.school);
		if (match.length === 0) {
			return false;
		}
		return (match[0]['value'] || '').toLowerCase().includes('psicologia');
	}

	courseByKey(key: string) {
		return this.courseTypes.filter((course: any) => course['key'] === key)[0][
			'value'
		];
	}

	courseFatherByKey(key: string) {
		return this.courseTypes.filter((course: any) => course['key'] === key)[0][
			'father'
		];
	}
	dipartimentiById(id: String) {
		return this.dipartimenti.filter((dipartimento: any) =>dipartimento['id'] === id)[0];
	}


	getSSD() {
		// this._mainService.getSSD().subscribe((result) => {
		this._mainService.getSSDWithDetails().subscribe({
			next: (result) => {
				if (result) {
					this.ssds = result.ssd;
					this.degreeTypes = result.degree;
					this.languageLevels = result.language;
					this.degree_votes = result.degree_vote;
					this.courseTypes = result.course;
					this.schools = result.school;
					this.dipartimenti = result.dipartimenti;
          this.documents = result.documents;
				}
			},
			error: (e) => {
				this.applicationError = true;
				console.log(e);
			},
		});
	}

	prePopulateDescription(ssd: any, index: number) {
		this.admission.exams[index].description = ssd.value;
		this.resetAnswer();
	}

	ask(): void {
		this.asking = true;
		this.answer = '';
		this.askError = false;
		this.dipartimento = this.dipartimentiById(this.courseFatherByKey(this.course));
		const selectedCourse = this.courseTypes.filter((c: any) => c['key'] === this.course)[0];
		this.contactEmail = selectedCourse?.email || this.dipartimento.email;
		this._mainService.askExams(this.course, this.admission).subscribe({
			next: (answer) => {
				this.asking = false;
				this.answer = answer.answer;
				this.trace = answer.trace;
				this.reason = answer.reason;
				this.admission_id = answer.admission_id;
				this.short_id = answer.short_id;
				// console.log(this.answer);

        let conditions: Array<Condition> = [];
        Object.values(answer.errors).forEach((condition: string, index: number) => {
          let cnd: Condition = new Condition();
          cnd.subconditions = condition;
          cnd.label = Object.keys(answer.errors)[index];
          cnd.position = !isNaN(this.conditionsOrder.indexOf(cnd.label)) ? this.conditionsOrder.indexOf(cnd.label) : 99;
          conditions.push(cnd);
        });
				this.reasons = conditions.sort((a: any,b: any) => a.position - b.position);

			},
			error: (e) => {
				this.asking = false;
				this.askError = true;
				console.error('Server Error:', e);
			},
		});
		// console.log(this.answer);
	}

	askWithPrompt() {
		this.asking = true;
		this.answer = '';
		this.askError = false;
		this._mainService.askWithPrompt(this.prompt).subscribe({
			next: (answer) => {
				this.asking = false;
				this.answer = answer.answer;
				this.trace = answer.trace;
				this.reason = answer.reason;
			},
			error: (e) => {
				this.asking = false;
				this.askError = true;
				console.error('Prompt error:', e);
			},
		});
	}

	getObjectValues(object: object) {
		return Object.values(object);
	}

  getObjectKeys(object: object) {
		return Object.keys(object);
	}

	capitalizedCourse(course: any) {
		var splitStr = course.toLowerCase().split(' ');
		for (var i = 0; i < splitStr.length; i++) {
			// You do not need to check if i is larger than splitStr length, as your for does that for you
			// Assign it back to the array
			splitStr[i] =
				splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
		}
		// Directly return the joined string
		return splitStr.join(' ');
	}

	toggleTemplate() {
		this.showTemplate = !this.showTemplate;
	}

	toggleTrace() {
		this.showTrace = !this.showTrace;
	}

	addExam(): void {
		const exam = new Exam();
		this.admission.exams.push(exam);
	}

	removeExam(i: number): void {
		const newExams: Exam[] = [];
		for (var j = 0; j < this.admission.exams.length; j++) {
			if (i != j) {
				newExams.push(this.admission.exams[j]);
			}
		}
		this.admission.exams = newExams;
	}

	isFailure() {
		return this.answer === 'NO';
	}

	isSuccess() {
		return this.answer === 'YES';
	}

	onFileChange(event: Event) {
		const files = (event.target as HTMLInputElement).files;
		if (files && files.length > 0) {
			this.selectedFile = files[0];
		}
		this.onFileSubmit();
	}

	onFileSubmit() {
		if (this.selectedFile) {
			this.documentProcessing = true;
			// Send the file using an HTTP service or other methods
			const formData = new FormData();
			formData.append('file', this.selectedFile);
			// ... send formData using your preferred HTTP service
			this._mainService.digestExamsDocument(this.selectedFile).subscribe({
				next: (digestedExams) => {
					this.documentParseOk = true;
					this.admission.name = digestedExams['name'];
					this.admission.cf = digestedExams['cf'];
					this.admission.degree_type = digestedExams['degree_type'];
					this.admission.exam_vote = digestedExams['degree_vote'];
					this.admission.languageLevel = digestedExams['english_exam_code'];
					this.admission.new_file_name = digestedExams['new_file_name'];
					this.admission.exams = [];
					if (digestedExams['exams']) {
						for (var examDigestedIndex in digestedExams['exams']) {
							const examDigested = digestedExams['exams'][examDigestedIndex];
							const exam = new Exam();
							exam.cfu = Number(examDigested['cfu']);
							exam.description = examDigested['desc'];
							exam.ssd = examDigested['cod'];
							this.admission.exams.push(exam);
						}
					}
					this.documentProcessing = false;
					setTimeout(() => {
						this.currentStep = 2;
					}, 2000);
				},
				error: (e) => {
					this.documentParseOk = false;
					this.documentProcessing = false;
				},
			});
		}
	}

	save() {
		this.savingMessage = 'Saving...';
		this._mainService.saveAdmission(this.admission).subscribe({
			next: (admission) => {
				if (admission) {
					this.savingMessage = 'Done!';
					this.admission = admission;
					setTimeout(() => {
						this.savingMessage = null;
					}, 1000);
				}
			},
			error: (e) => {
				this.savingMessage = 'Errore durante il salvataggio, riprova.';
				console.error('Save error:', e);
				setTimeout(() => {
					this.savingMessage = null;
				}, 3000);
			},
		});
	}

  documentUrl(){
    let course: any = this.courseTypes.filter(
			(course: any) => course.key === this.course
		)[0];

    let document = this.documents.filter(
			(document: Document) => document.id === course.document
		)[0];

    //return document ? (document.value + '/' + document.key) : null;
	return "https://www.unipd.it/avvisi-ammissione-lauree-magistrali";
  }

  onlyPositiveNumbers(examIndex: number) {
    if(this.admission.exams[examIndex].cfu !== null && !isNaN(this.admission.exams[examIndex].cfu)){
      this.admission.exams[examIndex].cfu = Math.abs(this.admission.exams[examIndex].cfu)
    }
  }
}
